import { render, staticRenderFns } from "./acuerdo-comision.vue?vue&type=template&id=2e1160a4&scoped=true&"
import script from "./acuerdo-comision.vue?vue&type=script&lang=js&"
export * from "./acuerdo-comision.vue?vue&type=script&lang=js&"
import style0 from "./acuerdo-comision.vue?vue&type=style&index=0&id=2e1160a4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e1160a4",
  null
  
)

export default component.exports